import '@/plugins/firebase'
import '@/plugins/meta'

import AOS from '@/plugins/aos'
import App from '@/App.vue'
import Vue from 'vue'
import router from '@/router'
import vuetify from '@/plugins/vuetify'

Vue.config.productionTip = false;

new Vue({
  created() {
    AOS();
  },
  render: h => h(App),
  router,
  vuetify,
}).$mount('#app');
